import { BillingItemsArray } from './billingItemsArray';
import { BillingSetup } from './billingSetup';
import { Model } from './model';
// import {TestbedOwner} from "./testbed-owner";

export class BillingSetupItemArray extends Model {

  billingSetup!: BillingSetup;

  billingItems!: BillingItemsArray[];
}
